module.exports = __webpack_public_path__ + "img/Semper_Fi_Cycle@3x.587a5461.webp";